import React from "react";
import { Button, Input, Layout, message, Icon } from "antd";
import "./search.css";

const Search = ({
  logout,
  login,
  user,
  handleSubmit,
  handleChange,
  inputValue,
  example,
}) => {
  const info = () => {
    message.info("Для поиска войдите в аккаунт");
  };
  const input = (
    <Input
      placeholder="название/doi/pmid статьи"
      className="search"
      value={example || inputValue}
      allowClear
      onPressEnter={example ? null : handleSubmit}
      onChange={example ? null : handleChange}
      onClick={example ? info : null}
    />
  );
  return (
    <Layout className="inputContainer">
      {input}
      {!user && example ? null : (
        <Button type="primary" className="login" onClick={logout}>
          <Icon type="logout" />
        </Button>
      )}
    </Layout>
  );
};
export default Search;
